module.exports = __webpack_public_path__ + "3218742e8a386bf6dc5d413edd851b44.svg";